import styled from 'styled-components'

export const LogoWrapper = styled.div`
	display: flex;
	justify-content: center;
`

export const Logo = styled.img`
	height: var(--el-hg-sm);
	/* width: var(--el-hg-sm); */
	margin: var(--mg-lg) 0;
`
